import React, {Component, PropTypes} from 'react'
class Image extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.src = props.src + '?auto=webp&disable=upscale'
    if(props.useHeightAndWidth){
      this.src += '&height=' + props.height
      this.src  += '&width=' + props.width
    }

  }

  render() {
    //lazyloaded is a frankly class that attaches some features (maybe)
    if(!this.props.linkTo)
      return(
        <div className='gnm-image'>
          <img src={this.src} alt={this.props.alt} className='img-responsive lazyloaded' />
        </div>
      )

    return (
      <a className='gnm-image' href={this.props.linkTo}>
        <img src={this.src} alt={this.props.alt} className='img-responsive lazyloaded' />
      </a>
    )
  }
}

export default Image



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Image/index.js